<template>
  <div class="modal-container">
    <div class="overlap-modal" @click="closeModal()"></div>
    <div class="content-modal" :class="isCorner && 'corner'">
      <div v-if="!isHideClose" class="close-icon" @click="closeModal()">
        <img src="@/assets/icon/close.svg" alt="close icon" />
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: ['isCorner', 'isHideClose'],
  components: {},
  methods: {
    closeModal() {
      this.$emit('closeModal');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  z-index: 99;

  .overlap-modal {
    position: fixed;
    top: 0;
    left: 0;
    // background: #000;
    opacity: 0.4;
    width: 100vw;
    height: 100vh;
  }
  .content-modal {
    background: #fff;
    border-radius: 12px;
    z-index: 1;
    position: absolute;
    box-shadow: 0px 0px 5px 4px rgba(0, 0, 0, 0.25);
    -webkit-box-shadow: 0px 0px 5px 4px rgba(0, 0, 0, 0.25);
    -moz-box-shadow: 0px 0px 5px 4px rgba(0, 0, 0, 0.25);
    animation: unfoldIn 0.5s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;

    &.corner {
      top: 82px;
      right: 10%;
    }

    .close-icon {
      position: absolute;
      top: 4px;
      right: 4px;
      padding: 8px;
      cursor: pointer;
    }
  }

  @keyframes unfoldIn {
    0% {
      transform: scaleY(0.005) scaleX(0);
    }
    50% {
      transform: scaleY(0.005) scaleX(1);
    }
    100% {
      transform: scaleY(1) scaleX(1);
    }
  }
}

@media (max-width: $breakpoint-tablet) {
  .modal-container {
    .content-modal {
      &.corner {
        top: unset;
        right: unset;
      }
    }
  }
}
@media (max-width: $breakpoint-mobile) {
  .modal-container {
    .content-modal {
      width: 95vw;
      margin: auto;
    }
  }
}
</style>
